import MuiIconButton from '@mui/material/IconButton';
import type { IconButtonProps } from './IIconButton';
import { styles } from './styles';

const IconButton = ({ sx, ...rest }: IconButtonProps) => (
    <MuiIconButton
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    />
);

export default IconButton;
